<template>
  <SidebarNavItem text="filter-item" :level="1">
    <template #nav-bar-text>
      <slot name="filter-item-content">
        <div class="filter-item-label">
          <span v-text="label" />
          <span
            v-if="selectedFilterLabel"
            class="selected"
            v-text="selectedFilterLabel"
          />
        </div>
        <Icons
          name="arrow"
          :rotate="180"
          style="--icon-size: 18px; float: right"
        />
      </slot>
    </template>
  </SidebarNavItem>
</template>

<script>
import Icons from '@sephora-asia/atoms-icons/Icons.vue'
import SidebarNavItem from '@sephora-asia/core-sidebar-nav-item/SidebarNavItem.vue'

export default {
  name: 'FilterItemMobile',

  components: {
    Icons,
    SidebarNavItem
  },

  props: {
    label: {
      type: String,
      default: ''
    },

    selectedFilterLabel: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-item-label {
  font-size: 14px;
  font-weight: bold;
  display: inline-flex;
  text-transform: uppercase;
  width: 90%;

  .selected {
    font-weight: 300;
    text-transform: none;
    margin-left: 15px;
    margin-right: 30px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
